import { fleetStages } from '../enums';
import { Fleet } from '../interfaces';
import { useFleetsQuery } from '../queries';
import { groupBy } from '../utils';

const orderedArrayOfStages = [
  fleetStages.PRODUCTION,
  fleetStages.PREPRODUCTION,
  fleetStages.STAGING,
  fleetStages.PILOT,
  fleetStages.PREPILOT,
  fleetStages.COMPLETED_PILOT,
  fleetStages.INTERNAL,
  fleetStages.TEST,
];

const mapStage = (item) => {
  if (item === null) {
    return {
      name: 'Ungrouped',
      displayId: orderedArrayOfStages.length + 1,
    };
  }

  return {
    name: item,
    displayId: orderedArrayOfStages.indexOf(item),
  };
};

export const useGroupedFleets = (searchFleet?: string) => {
  const { data: fleets, isLoading } = useFleetsQuery();

  function escapeRegExp(text = '') {
    return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '');
  }

  const regexp = new RegExp(String.raw`\b${escapeRegExp(searchFleet)?.split('').join('+?.*')}`, 'i');

  const filteredFleets = (fleets || [])?.filter((f: Fleet) => regexp.test(f.display_name));

  const fleetsToMap = filteredFleets;

  const mappedFleets = fleetsToMap
    ?.map((mappedFleet: Fleet) => {
      return { ...mappedFleet, stage: mapStage(mappedFleet.stage) };
    })
    .sort((a, b) => {
      if (a.stage.displayId === b.stage.displayId) {
        return 0;
      }
      return a.stage.displayId > b.stage.displayId ? 1 : -1;
    });

  const groupedFleets = groupBy(mappedFleets || [], (item) => item.stage.name);

  return { groupedFleets, isLoading, firstFleet: mappedFleets?.[0] };
};
